// composables/useCounts.js
import { ref, onMounted } from "vue";
import store from "../state/store";

export function useCounts() {
    const faqCount = ref(0);
    const commentCount = ref(0);
    const messageCount = ref(0);
    const orderCount = ref(0);

    const fetchCounts = async () => {
        try {
            await store.dispatch("getFaqCount").then(({ data }) => {
                faqCount.value = data.faqCount;
            });

            await store.dispatch("getCommentCount").then(({ data }) => {

                commentCount.value = data.commentCount;
            });

            await store.dispatch("getMessageCount").then(({ data }) => {
                messageCount.value = data.messageCount;
            });

            await store.dispatch("getOrderCount").then(({ data }) => {
                orderCount.value = data.orderCount;
            });
        } catch (error) {
            console.error(error);
        }
    };

    onMounted(fetchCounts);

    return {
        faqCount,
        commentCount,
        messageCount,
        orderCount,
    };
}
